import {LanguageCodeType} from '../../service/language/language-const';

export const POPULAR_LANGUAGES: Array<LanguageCodeType> = ['ru', 'en', 'pl', 'uk', 'be'];
